export const NAV = [
  { label: "Inicio", to: "/" },
  { label: "Academia", to: "/academy" },
  { label: "Programas", to: "/programs" },
  { label: "Biblioteca", to: "/library" },
  { label: "Libros", to: "/books" },
  { label: "Podcast", to: "/podcast" },
  { label: "Eventos", to: "/events" },
  { label: "Fundador", to: "/founder" },
  { label: "Contacto", to: "/contact" },
];
